var twig = require("twig").twig,
    tokens = [],
    template = twig({"id":"$resolved:f13df47ee1712c3b73a249ac4e8809fa7052f3005119f3fa67e3ce28af73d58ed55048610d729bcd555935fdb2bd4de8dd72b935146981af1f1535ef5908da1f:arrow-right.svg.twig","data":[],"allowInlineIncludes":true,"rethrow":true});

module.exports = function(context) { return template.render(context); }

module.exports.tokens = tokens;